import { render, staticRenderFns } from "./PopupNeedHelp.vue?vue&type=template&id=00461d68"
import script from "./PopupNeedHelp.vue?vue&type=script&lang=js"
export * from "./PopupNeedHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports